
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"290","height":"35","fill":"none"}},[_c('path',{attrs:{"fill":"#FE6C4B","fill-rule":"evenodd","d":"M285.972 16.5L271.293 1.821a.999.999 0 111.414-1.414l16.136 16.136a.999.999 0 010 1.414l-16.136 16.137a1 1 0 01-1.414-1.414l14.179-14.18H0v-2h285.972z","clip-rule":"evenodd"}})])
      }
    
      }
    